var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelfSchedulingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5658",
    "data-name": "Group 5658",
    transform: "translate(-1553 -589)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_877",
    "data-name": "Ellipse 877",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(1553 589)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5641",
    "data-name": "Group 5641",
    transform: "translate(1566 603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28969",
    "data-name": "Path 28969",
    d: "M12.474,20H4.895A1.9,1.9,0,0,1,3,18.105V9.579H20.053v2.842M14.368,3.895V2m0,1.895V5.789m0-1.895H10.105",
    fill: "none",
    stroke: "#486eb1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28970",
    "data-name": "Path 28970",
    d: "M3,10V6A2,2,0,0,1,5,4H7",
    fill: "none",
    stroke: "#486eb1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28971",
    "data-name": "Path 28971",
    d: "M7,2V6",
    transform: "translate(-0.211)",
    fill: "none",
    stroke: "#486eb1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28972",
    "data-name": "Path 28972",
    d: "M21,10V6a2,2,0,0,0-2-2h-.5",
    transform: "translate(-0.947)",
    fill: "none",
    stroke: "#486eb1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28973",
    "data-name": "Path 28973",
    d: "M14.992,18h3M21,18H17.992m0,0V15m0,3v3",
    transform: "translate(-0.947 -1)",
    fill: "none",
    stroke: "#486eb1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfSchedulingIcon);
export default __webpack_public_path__ + "static/media/selfSchedulingIcon.f2b103a36327c0b25cc189b6e2fcb5f8.svg";
export { ForwardRef as ReactComponent };